export const menuData = [
  {
    type: "link",
    visible: false,
    to: "",
    label: "Ссылки",
  },
  {
    type: "link",
    visible: true,
    to: "/kie/characters",
    label: "Персонажи",
  },
  {
    type: "link",
    visible: true,
    to: "/kie/magicItems",
    label: "Предметы",
  },
  {
    type: "link",
    visible: true,
    to: "/kie/sessions",
    label: "Сессии",
  },
  {
    type: "link",
    visible: false,
    to: "",
    label: "Заклинания",
  },
  { type: "line" },
  {
    type: "link",
    visible: false,
    to: "/kie/initiatives",
    label: "Инициативы",
  },
  { type: "line" },
  {
    type: "link",
    visible: true,
    to: "/kie/addComment",
    label: "Оставить комментарий",
  },
  {
    type: "link",
    visible: false,
    to: "",
    label: "Настройки",
  },
];
